export default __webpack_public_path__ + "static/media/scenario-b-progress-expanded.72042091.png";